<template>
  <v-row no-gutters class="flex-nowrap px-1" align="center" justify="center" style="height: 60px">
    <v-col cols="auto" v-for="(col, idx) of cols" :key="idx" :style="`width: ${col.width}`" class="text-center">
      <template v-if="col.attributes?.length">
        <v-row no-gutters justify="center">
          <v-col :cols="12 / col.attributes?.length" class="px-1" v-for="(attribute, idx) of col.attributes" :key="idx">
            <template v-if="attribute.name === lightingSituationAttributes['type_attribute']">
              <data-input
                v-model="computedItem.properties[attribute.name]"
                v-bind="{
                  ...$_filterObjectKeys(attribute, { notAllowedKeys: ['label'] }),
                  ...(col.disabledFunction
                    ? {
                        disabled: col.disabledFunction(
                          computedItem.properties[lightingSituationAttributes.type_attribute]
                        ),
                      }
                    : {}),
                }"
                @change="onAttributeChange(attribute, $event)"
              >
                <template #item="{ item }">
                  <img v-if="getImg(item)" :src="getImg(item)" width="28.5" height="28.5" />
                  <span v-else>{{ item }}</span>
                </template>
                <template #selection="{ item }">
                  <img v-if="getImg(item)" :src="getImg(item)" width="28.5" height="28.5" />
                  <span v-else>{{ item }}</span>
                </template>
              </data-input>
            </template>
            <template v-else>
              <data-input
                v-model="computedItem.properties[attribute.name]"
                v-bind="{
                  ...$_filterObjectKeys(attribute, { notAllowedKeys: ['label'] }),
                  ...(col.disabledFunction
                    ? {
                        disabled: col.disabledFunction(
                          computedItem.properties[lightingSituationAttributes.type_attribute]
                        ),
                      }
                    : {}),
                }"
                @change="onAttributeChange(attribute, $event)"
              />
            </template>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="col.name === 'calculator'">
        <v-row no-gutters align="center" justify="center">
          <base-button
            class="mr-0 px-5"
            translation-path="button.calculate"
            @click="onCalculateToggle()"
            :disabled="loading || !computedItem.properties[lightingSituationAttributes.situation_attribute]"
          />
          <v-chip
            v-if="computedItem.calculatorBadge"
            :color="computedItem.badgeColor"
            label
            class="ml-1"
            :class="{
              'white--text': !$_isHexColorLight(computedItem.badgeColor),
              'font--text': $_isHexColorLight(computedItem.badgeColor),
            }"
          >
            {{ computedItem.calculatorBadge }}
          </v-chip>
        </v-row>
      </template>
      <template v-else-if="col.name === 'options1'">
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <v-icon
              color="rgba(0,0,0,0.7)"
              size="20"
              class="border-right"
              v-on="on"
              :disabled="loading || !computedItem.properties[lightingSituationAttributes.situation_attribute]"
              @click="onCopyToggle(col, computedItem)"
            >
              mdi-content-copy
            </v-icon>
          </template>
          {{ $i18n.t('sidebar.masterplanStreets.dialog.copyValueToOthers') }}
        </v-tooltip>
      </template>
      <template v-else-if="col.name === 'options2'">
        <v-row no-gutters class="px-3">
          <v-tooltip bottom color="font">
            <template #activator="{ on }">
              <v-icon
                color="rgba(0,0,0,0.7)"
                size="20"
                v-on="on"
                :disabled="loading"
                @click="onCopyToggle(col, computedItem)"
              >
                mdi-content-copy
              </v-icon>
            </template>
            {{ $i18n.t('sidebar.masterplanStreets.dialog.copyValueToOthers') }}
          </v-tooltip>
          <v-spacer />
          <v-icon color="error" @click="onDelete()" :disabled="loading">
            mdi-close
          </v-icon>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';
import DataInput from '@/components/DataInput';
export default {
  name: 'MasterplanStreetsWidgetDialogElement',
  components: { DataInput },
  props: {
    cols: {
      type: Array,
      default: () => {
        return [];
      },
    },
    item: {
      type: Object,
    },
    lightingSituationValues: {
      type: Object,
    },
    typeAttributeDict: {
      type: Object,
      default: () => {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    token: get('authentication/token'),
    masterplanSituationsDataSourceMapping: get(
      'admin/modulesMapping@masterplan_2_streets@masterplan_situation_datasource'
    ),
    lightingSituationAttributes() {
      return this.masterplanSituationsDataSourceMapping?.settings || {};
    },
    computedItem: {
      get() {
        return this.item;
      },
      set(nV) {
        this.$emit('update:item', nV);
      },
    },
  },
  methods: {
    onAttributeChange(attribute, value) {
      if (attribute.name === this.lightingSituationAttributes['situation_attribute']) {
        this.$emit('refreshFeaturesMapping');
      } else if (attribute.name === this.lightingSituationAttributes['type_attribute']) {
        for (const col of this.cols) {
          if (
            col.disabledTypes?.length &&
            col.disabledTypes.find(type => this.lightingSituationValues[`type_${type}_value`] === value)
          ) {
            col.attributes.forEach(attr => {
              delete this.computedItem.properties[attr.name];
            });
          }
          if (
            col.enabledTypes?.length &&
            !col.enabledTypes.find(type => this.lightingSituationValues[`type_${type}_value`] === value)
          ) {
            col.attributes.forEach(attr => {
              delete this.computedItem.properties[attr.name];
            });
          }
        }
        this.$emit('refreshFeaturesMapping');
      }
    },
    onCopyToggle(col, item) {
      const copyAttributes = col.copy
        .map(col => {
          return this.cols.find(c => c.name === col);
        })
        .reduce((total, current) => {
          total = [
            ...total,
            ...(['calculator', 'situation'].includes(current.name)
              ? [current]
              : current.attributes.map(a => {
                  return { ...a, col: current.name };
                })),
          ];
          return total;
        }, []);
      const attributesLabels = copyAttributes.map(element => {
        if (element.name === 'situation') {
          return {
            label: element.attributes.at(-1).label,
            value: element.attributes.reduce((total, current) => {
              total += item.properties[current.name] !== null ? item.properties[current.name] : '';
              return total;
            }, ''),
          };
        } else if (element.name === 'calculator') {
          return { label: this.$i18n.t(element.translationPath), value: item.calculatorBadge };
        } else {
          return { label: element.label, value: item.properties[element.name] };
        }
      });
      const attributesValues = copyAttributes.reduce((total, current) => {
        if (current.name === 'situation') {
          current.attributes.forEach(attr => {
            total[attr.name] = { col: current.name, value: item.properties[attr.name] };
          });
        } else if (current.name === 'calculator') {
          total[this.lightingSituationAttributes['calculation_attribute']] = {
            col: current.name,
            value: item.properties[this.lightingSituationAttributes['calculation_attribute']],
          };
        } else {
          total[current.name] = { col: current.col, value: item.properties[current.name] };
        }
        return total;
      }, {});
      this.$emit('onCopyToggle', { item, attributesLabels, attributesValues });
    },
    onCalculateToggle(item = this.computedItem) {
      this.$emit('onCalculateToggle', item);
    },
    onDelete(item = this.computedItem) {
      this.$emit('onDelete', item);
    },
    getImg(item) {
      return this.typeAttributeDict[item]?.image
        ? `${process.env.VUE_APP_API_URL}/dicts_images/${this.typeAttributeDict[item]?.image}?token=${this.token}`
        : '';
    },
  },
};
</script>
<style lang="scss" scoped>
.border-right::before {
  height: 40px;
  padding-top: 10px;
  padding-right: 12px;
  @include border(right);
}
::v-deep {
  .v-input--is-disabled {
    background-color: #f1f1f1 !important;
  }
}
</style>
